'use client';
import { CircleX } from 'lucide-react';
import { ReactElement, useState, ChangeEvent } from 'react';
import { Input } from '@mui/base/Input';
import { PatternFormat } from 'react-number-format';
import Button from './button';
import sendMessageToTelegram from '@/app/hooks/telegram/useSendMessage';
import PhoneVector from './svg/contacts/phone-vector';

export default function CallbackButton(): ReactElement {
  const [hideWindow, setHideWindow] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '+ 7' });
  const [errors, setErrors] = useState({ phone: '' });

  // Функция для валидации телефона
  const validatePhone = (phone: string): boolean => {
    const regex = /^7\d{10}$/;
    return regex.test(phone);
  };

  const handlePhoneChange = (values: { value: string }) => {
    const { value } = values;
    setFormData((prev) => ({ ...prev, phone: value }));
    setErrors((prev) => ({ ...prev, phone: '' }));
  };

  const handleSubmit = () => {
    const isPhoneValid = validatePhone(formData.phone);

    if (!isPhoneValid) {
      setErrors((prev) => ({
        ...prev,
        phone: 'Введите корректный телефон.',
      }));
      return;
    }

    // console.log('Отправка данных:', formData);
    const formattedFormData = ` 
        Новая заявка на обратный звонок: 
        Контактные данные:
        Имя: ${formData.name}
        Телефон: ${formData.phone}`;
    sendMessageToTelegram('6488088364', formattedFormData);
    setHideWindow(false);
  };

  return (
    <div className="flex items-center gap-4">
      <div
        className="flex items-center gap-4"
        onClick={() => setHideWindow(true)}
      >
        <PhoneVector width={24} height={24} strokeWidth={0.1} />
        <p className="text-sm">Заказать звонок</p>
      </div>

      {hideWindow && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
          <div className="relative w-11/12 max-w-md rounded-lg bg-white p-6 shadow-lg">
            <CircleX
              size={24}
              color="black"
              className="absolute right-5 top-5 cursor-pointer"
              onClick={() => setHideWindow(false)}
            />
            <p className="mb-5 mt-6 text-center text-xl text-black">
              Заказать обратный звонок
            </p>
            <div className="flex flex-col gap-3">
              <div className="flex items-center rounded-full border border-black px-4">
                <Input
                  placeholder="Ваше имя"
                  type="text"
                  className="w-full rounded-full border-none text-black focus:outline-none"
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setFormData((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="flex flex-col">
                <div className="flex items-center rounded-full border border-black px-4">
                  <PatternFormat
                    placeholder="Телефон"
                    type="tel"
                    className="w-full rounded-full border-none text-black focus:outline-none"
                    format="+# (###) ###-##-##"
                    mask="_"
                    value={formData.phone}
                    onValueChange={handlePhoneChange}
                  />
                </div>
                {errors.phone && (
                  <p className="text-sm text-red-500">{errors.phone}</p>
                )}
              </div>
            </div>
            <Button
              onClick={handleSubmit}
              className="mt-8 w-full bg-red-regular"
            >
              Отправить
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
